module.exports = __webpack_public_path__ + "static/lifetime-fitness-diamond-membership-icon-7f40178d889825e42c60c263e2a8029f.svg";